import { render, staticRenderFns } from "./SubmittedApproveAction.vue?vue&type=template&id=a22dce90&"
import script from "./SubmittedApproveAction.vue?vue&type=script&lang=js&"
export * from "./SubmittedApproveAction.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedApproveAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports